import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from '../../../../../src/app/core/models/generic-models';
import { IForgotPasscodeVerifyRequest, IForgotPasscodeVerifyResponse, IVerifyOTPRequest, IVerifyOTPResponse } from '../models/forgot-passcode-verify.model';

export const loadForgotPasscodeVerify = createAction(
  '[ForgotPasscodeVerify] Load ForgotPasscodeVerify',
  props<{ request: IForgotPasscodeVerifyRequest }>()
);

export const loadForgotPasscodeVerifySuccess = createAction(
  '[ForgotPasscodeVerify] Load ForgotPasscodeVerify Success',
  props<{ response: IForgotPasscodeVerifyResponse }>()
);

export const loadForgotPasscodeVerifyFailure = createAction(
  '[ForgotPasscodeVerify] Load ForgotPasscodeVerify Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);

export const clearForgotPasscodeVerifyFailure = createAction('[ForgotPasscodeVerify] Clear ForgotPasscodeVerify Failure');

export const clearForgotPasscodeVerifySuccess = createAction('[ForgotPasscodeVerify] Clear ForgotPasscodeVerify Success');


export const verifyOTP = createAction(
  '[ForgotPasscodeVerify] Load VerifyOTP',
  props<{ request: IVerifyOTPRequest }>()
);

export const verifyOTPSuccess = createAction(
  '[ForgotPasscodeVerify] Load VerifyOTP Success',
  props<{ response: IVerifyOTPResponse }>()
);

export const verifyOTPFailure = createAction(
  '[ForgotPasscodeVerify] Load VerifyOTP Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);